import React from "react";
import axios from "axios";

const UpdateRsvpButton = () => {
  const handleUpdateRsvp = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/update-rsvp`);
      alert("RSVPs updated successfully");
    } catch (error) {
      console.error("Error updating RSVPs:", error);
      alert("Failed to update RSVPs");
    }
  };

  return <button onClick={handleUpdateRsvp}>Update RSVP</button>;
};

export default UpdateRsvpButton;
